import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merges Tailwind classes, resolving conflicts in favour of the last one.
 * Plain clsx would keep both `p-2` and `p-4`; twMerge drops the loser, which
 * is what makes component-level class overrides predictable.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
